import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiSpringboot,
  SiApachekafka,
  SiHibernate,
  SiDocker,
  SiRedis,
  SiSwagger,
  SiElasticsearch,
} from "react-icons/si";

const frameworks = [
  { label: "Spring Boot", icon: <SiSpringboot /> },
  { label: "Kafka", icon: <SiApachekafka /> },
  { label: "Elasticsearch", icon: <SiElasticsearch /> },
  { label: "Hibernate", icon: <SiHibernate /> },
  { label: "Docker", icon: <SiDocker /> },
  { label: "Redis", icon: <SiRedis /> },
  { label: "Swagger", icon: <SiSwagger /> },
];

function FraLibStack() {
  return (
    <>
      <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
        {frameworks.map((item) => (
          <Col xs={4} md={2} className="tech-icons" key={item.label}>
            {item.icon}
            <div className="tech-label">{item.label}</div>
          </Col>
        ))}
      </Row>

      <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
        <Col md={10} className="tech-badge-wrapper">
          <span className="tech-badge">Spring Security</span>
          <span className="tech-badge">REST API</span>
          <span className="tech-badge">gRPC</span>
          <span className="tech-badge">Feign Client</span>
          <span className="tech-badge">MQTT</span>
        </Col>
      </Row>

      <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
        <Col md={10} className="tech-badge-wrapper">
          <span className="tech-badge">Microservices</span>
          <span className="tech-badge">Distributed Systems</span>
          <span className="tech-badge">Event-Driven Architecture</span>
          <span className="tech-badge">Database Optimization</span>
        </Col>
      </Row>

      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <Col md={10} className="tech-badge-wrapper">
          <span className="tech-badge">OpenAI API</span>
          <span className="tech-badge">Claude API</span>
          <span className="tech-badge">Prompt Engineering</span>
          <span className="tech-badge">AI Integration</span>
        </Col>
      </Row>
    </>
  );
}

export default FraLibStack;